import React from 'react';
import { Link } from 'react-router-dom';
import './HeroBanner.css';

const HeroBanner = ({ title, breadcrumbs = [] }) => {
  return (
    <section className="hero-wrap hero-wrap-2 js-fullheight hero-banner" data-stellar-background-ratio="0.5">
      <div className="overlay"></div>
      <div className="container">
        <div className="row no-gutters slider-text js-fullheight align-items-end justify-content-start">
          <div className="col-md-9 ftco-animate pb-5">
            <p className="breadcrumbs">
              <span className="mr-2">
                <Link to="/">Home <i className="ion-ios-arrow-forward"></i></Link>
              </span>
              {breadcrumbs.map((crumb, index) => (
                <span key={index}>
                  {index > 0 && <i className="ion-ios-arrow-forward"></i>} {crumb}
                </span>
              ))}
            </p>
            <h1 className="mb-3 bread">{title}</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;


